import { useRef } from 'react';

import { useRuntime } from '@xing-com/crate-xinglet/internal';
import type { Variant } from '@xing-com/splitkit';
import { registerExperiment } from '@xing-com/splitkit';

export const useRegisterExperiments = (): void => {
  const runtime = useRuntime();
  const registered = useRef(false);

  if (registered.current) return;

  for (const { contributes } of Object.values(runtime.metadataMap)) {
    if (!contributes?.experiments) continue;

    for (const experiment of contributes.experiments) {
      const { name, supportedVariants, experimentType } = experiment;

      registerExperiment(
        name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        supportedVariants as ['A', ...Variant[]],
        experimentType
      );
    }
  }

  registered.current = true;
};
